var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8C22 11.3137 19.3137 14 16 14C15.1196 14 14.2835 13.8104 13.5303 13.4697L11.8931 15.1069C11.812 15.188 11.7055 15.2387 11.5915 15.2507L9.61024 15.4578C9.37524 15.4824 9.18952 15.6681 9.16495 15.9031L8.9815 17.6575C8.95692 17.8925 8.7712 18.0782 8.53621 18.1028L6.78181 18.2863C6.54681 18.3108 6.36109 18.4966 6.33652 18.7316L6.12934 20.7128C6.11742 20.8269 6.06667 20.9333 5.98561 21.0144L5.14645 21.8536C5.05268 21.9473 4.9255 22 4.79289 22H2.5C2.22386 22 2 21.7761 2 21.5V19.2071C2 19.0745 2.05268 18.9473 2.14645 18.8536L10.5303 10.4697C10.1896 9.71653 10 8.88041 10 8C10 4.68629 12.6863 2 16 2C19.3137 2 22 4.68629 22 8ZM17 9.5C18.3807 9.5 19.5 8.38071 19.5 7C19.5 5.61929 18.3807 4.5 17 4.5C15.6193 4.5 14.5 5.61929 14.5 7C14.5 8.38071 15.6193 9.5 17 9.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyAlt);
export default __webpack_public_path__ + "static/media/key-alt.b70ecd95f4c38e68c858934135e84c49.svg";
export { ForwardRef as ReactComponent };